import type { LadderTierKey } from "../types";

import { resolveImageSrc } from "../../Icons";
import { tierBadgeFor } from "../tierBadge";

type TierBadgeImageProps = {
  tierKey: LadderTierKey | null;
  className?: string;
};

/** Renders nothing for tiers without badge artwork (e.g. numbered "Tier 1"). */
export const TierBadgeImage = ({ tierKey, className }: TierBadgeImageProps) => {
  const badge = tierBadgeFor(tierKey);
  if (!badge) return null;

  return (
    <img
      src={resolveImageSrc(badge)}
      alt=""
      aria-hidden="true"
      className={className}
    />
  );
};
